export function format(format: string, parameters: string[]): string {
    return format.replace(/{(\d+)}/g, function (match, number: number) {
        return typeof parameters[number] !== "undefined" ? parameters[number] : match;
    });
}

export const t = (key: string, fallback: string, ...parameters: string[]): string =>
    format(window.i18n?.[key] || fallback, parameters);
